import { GANJAGODDESS } from "./website";

export const RESULT_FOUND = '1';
export const RESULT_TYPO_TOLERENCE = '2';
export const RESULT_NOT_FOUND = '3'
export const SORT_TYPES = {
  recommeded: 'none',
  deals: 'deals',
  priceLowToHigh: 'price-low-to-high',
  priceHightToLow: 'price-high-to-low',
}

const isGG = process.env.NEXT_PUBLIC_APP === GANJAGODDESS;
export const sortFilter = [
  ...(isGG ? [{
    name: 'product_price',
    label: 'Recommended',
    id: 'none',
    type: 'radio'
  }] : []
  ),
  {
    name: 'product_price',
    label: 'Deals First',
    id: 'deals',
    type: 'radio'
  },
  {
    name: 'product_price',
    label: 'Price - Low to High',
    id: 'price-low-to-high',
    type: 'radio'
  },
  {
    name: 'product_price',
    label: 'Price - High to Low',
    id: 'price-high-to-low',
    type: 'radio'
  },
  {
    name: 'product_price',
    label: 'THC - Low to High',
    id: 'thc-low-to-high',
    type: 'radio'
  },
  {
    name: 'product_price',
    label: 'THC - High to Low',
    id: 'thc-high-to-low',
    type: 'radio'
  }
];